import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { SnackbarProvider } from 'notistack';

import { Scrollbars } from 'react-custom-scrollbars';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Ficha } from './components/Ficha'

import './App.css';
import Master from './components/Master';

const theme = createMuiTheme({
  palette: {
    text: {
      primary: 'rgb(255,255,255)'
    },
    primary: {
      main: 'rgb(255,255,255)',
    },

    background: {
      paper: 'rgba(0,0,0, 0.8)',
    }
  },
  overrides: {
    MuiSelect: {
      select: {
        color: 'white',
      },
      root: {
        color: 'white'
      },
      outlined: {
        color: 'white'
      },
      icon: {
        color: 'white'
      },
    },
    MuiFormHelperText: {
      root: {
        color: 'white'
      },
    },
    MuiSvgIcon: {
      root: {
        color: 'white'
      },
    },
    MuiInput: {
      underline: {
        borderBottom: '2px solid rgba(255, 255, 255, 0.9)'
      }
    },
    MuiFormControl: {
      root: {
        color: 'rgb(255,255,255)',
      },
    },
    MuiFormLabel: {
      root: {
        color: 'rgb(255,255,255)',
      },
    },
    MuiInputLabel: {
      root: {
        color: 'rgb(255,255,255)',
      },

    },
  },
});

function App() {
  return (
    <SnackbarProvider>
      <Scrollbars
        style={{ height: '100vh' }}>
        <ThemeProvider theme={theme}>
          <Router>
            <Switch>
              <Route path="/mestre">
                <Master />
              </Route>
              <Route path="/">
                <Ficha />
              </Route>
            </Switch>
          </Router>
        </ThemeProvider>
      </Scrollbars>
    </SnackbarProvider>
  );
}

export default App;
